import React from 'react'
import { AppSelectionBar, AppSelectionBarButton } from '@components'
import { isOpenReportsTransferModal } from 'Pages/Admin/ReportsHandler/@signals'


export default function ReportsHandlerSelectToolbar({selectedData, setSelectedRows}) {


	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarButton
			icon="people-arrows"
			label="Transfer"
			title="Transfer selected reports to another user"
			onClick={() => {
				setSelectedRows([])
				isOpenReportsTransferModal.value = selectedData
			}}
		/>
	</AppSelectionBar>
}